module.exports = __webpack_public_path__ + "img/郎中乡.60564b20.png";